/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mvp_Sprint_Harden_Detail6Inputs */

const en_svc_mvp_sprint_harden_detail6 = /** @type {(inputs: Svc_Mvp_Sprint_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analytics, hardening and 14-day support.`)
};

const ar_svc_mvp_sprint_harden_detail6 = /** @type {(inputs: Svc_Mvp_Sprint_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحليلات وتحصين و14 يوما من الدعم.`)
};

const bn_svc_mvp_sprint_harden_detail6 = /** @type {(inputs: Svc_Mvp_Sprint_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অ্যানালিটিক্স, শক্ত করা আর ১৪ দিন সাপোর্ট।`)
};

const de_svc_mvp_sprint_harden_detail6 = /** @type {(inputs: Svc_Mvp_Sprint_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analytics, Härtung und 14 Tage Support.`)
};

const es_svc_mvp_sprint_harden_detail6 = /** @type {(inputs: Svc_Mvp_Sprint_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analítica, endurecimiento y 14 días de soporte.`)
};

const fr_svc_mvp_sprint_harden_detail6 = /** @type {(inputs: Svc_Mvp_Sprint_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analytique, durcissement et 14 jours de support.`)
};

const pt_svc_mvp_sprint_harden_detail6 = /** @type {(inputs: Svc_Mvp_Sprint_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análise, endurecimento e 14 dias de suporte.`)
};

const zh_svc_mvp_sprint_harden_detail6 = /** @type {(inputs: Svc_Mvp_Sprint_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分析、加固，外加 14 天支持。`)
};

const tr_svc_mvp_sprint_harden_detail6 = /** @type {(inputs: Svc_Mvp_Sprint_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analitik, sertleştirme ve 14 gün destek.`)
};

const ru_svc_mvp_sprint_harden_detail6 = /** @type {(inputs: Svc_Mvp_Sprint_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Аналитика, закалка и 14 дней поддержки.`)
};

const pl_svc_mvp_sprint_harden_detail6 = /** @type {(inputs: Svc_Mvp_Sprint_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analityka, hartowanie i 14 dni wsparcia.`)
};

/**
* | output |
* | --- |
* | "Analytics, hardening and 14-day support." |
*
* @param {Svc_Mvp_Sprint_Harden_Detail6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mvp_sprint_harden_detail6 = /** @type {((inputs?: Svc_Mvp_Sprint_Harden_Detail6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mvp_Sprint_Harden_Detail6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mvp_sprint_harden_detail6(inputs)
	if (locale === "bn") return bn_svc_mvp_sprint_harden_detail6(inputs)
	if (locale === "de") return de_svc_mvp_sprint_harden_detail6(inputs)
	if (locale === "es") return es_svc_mvp_sprint_harden_detail6(inputs)
	if (locale === "fr") return fr_svc_mvp_sprint_harden_detail6(inputs)
	if (locale === "pt") return pt_svc_mvp_sprint_harden_detail6(inputs)
	if (locale === "zh") return zh_svc_mvp_sprint_harden_detail6(inputs)
	if (locale === "tr") return tr_svc_mvp_sprint_harden_detail6(inputs)
	if (locale === "ru") return ru_svc_mvp_sprint_harden_detail6(inputs)
	if (locale === "pl") return pl_svc_mvp_sprint_harden_detail6(inputs)
	return en_svc_mvp_sprint_harden_detail6(inputs)
});
export { svc_mvp_sprint_harden_detail6 as "svc_mvp-sprint_HARDEN_detail" }